import { Chip, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import * as React from "react";

export type TableCellIconChipProps = {
  data: { value: { text: string; icon: OverridableComponent<SvgIconTypeMap> }[] };
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
};

const TableCellIconChip: React.FC<TableCellIconChipProps> = ({ data, color = "default" }) => {
  return (
    <>
      {data.value.map((cell) => (
        <Chip
          icon={React.createElement(cell.icon, { sx: { mr: "0px !important" } })}
          label={cell.text}
          key={cell.text}
          size="small"
          color={color}
          sx={{ mr: 0.5 }}
        />
      ))}
    </>
  );
};

export default TableCellIconChip;
